import styled, {css} from 'styled-components';
import {FlexRow, SubHeading} from '@forecast-it/design-system';
import {CSS_CONSTANTS} from '../../../css_variables';

interface PageWrapperProps {
	overflowHidden: boolean;
}

export const PageWrapper = styled.div<PageWrapperProps>`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	flex: 1;
	height: initial;
	${({overflowHidden}) =>
		overflowHidden &&
		css`
			overflow: hidden;
		`}

	/* Keep the header / content aligned when page gets a scrollbar */
	.scrollbar {
		scrollbar-gutter: stable;
	}
`;

export const MyTimesheetWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	padding: 0 24px;
	/* if scrollbar-gutter is no supported by the browser (safari up to 18.1) 
	 * always add 14px of padding on the right side so the header and content 
	 * are aligned without the scrollbar
	 */
	@supports (scrollbar-gutter: stable) {
		padding: 0 10px 0 24px;
	}
	align-items: stretch;
	min-height: 100%;

	@media screen and (min-width: 2137px) {
		align-items: center;
	}
`;

export const MyTimesheetLeftColumnWrapper = styled.div`
	display: flex;
	flex-direction: column;
	flex-grow: 1;
`;

export const MyTimesheetsColumns = styled.div`
	display: flex;
	flex-direction: row;
	gap: 24px;
`;

export const MyTimesheetsSideModal = styled.div`
	position: sticky;
	top: 0;
	display: flex;
	width: 460px;
	height: 100%;
	flex-direction: column;
	background-color: ${props => props.theme.sys.color.background.neutral['2']};
	border: 1px solid ${props => props.theme.sys.color.border.decorative};
	border-radius: ${props => props.theme.sys.size.borderradius['3']};
	padding: 16px 24px 24px 24px;
`;

interface SectionWrapperProps {
	timeRegSideModalOpen: boolean;
}

export const TopSectionWrapper = styled.div<SectionWrapperProps>`
	max-width: ${props => (props.timeRegSideModalOpen ? '1578px' : '2089px')};
	@media screen and (min-width: 2137px) {
		width: ${props => (props.timeRegSideModalOpen ? '1578px' : '2065px')};
	}
`;

export const BottomSectionWrapper = styled.div<SectionWrapperProps>`
	flex-grow: 1;
	max-width: ${props => (props.timeRegSideModalOpen ? '1578px' : '2089px')};
	padding-top: 0;
	margin-bottom: 24px;

	.header-bar {
		min-height: 0;
	}
	.header-bar-center {
		flex-grow: 1;
	}
	@media screen and (min-width: 2137px) {
		width: ${props => (props.timeRegSideModalOpen ? '1578px' : '2065px')};
	}
`;

export const TabSectionWrapper = styled.div`
	position: sticky;
	top: 0;
	z-index: 2;
	background-color: #fff;
	padding: 0 24px;
	border-style: solid;
	border-color: ${props => props.theme.sys.color.border.decorative};
	border-width: 1px 1px 0 1px;
	border-radius: 8px 8px 0 0;
`;

export const InfoSectionWrapper = styled(FlexRow)`
	padding: 0 24px;
	border-style: solid;
	border-color: ${props => props.theme.sys.color.border.decorative};
	border-width: 0 1px 0 1px;
`;
export const TableWrapper = styled.div`
	padding: 0 24px;
	border-style: solid;
	border-color: ${props => props.theme.sys.color.border.decorative};
	border-width: 0 1px 1px 1px;
	border-radius: 0 0 8px 8px;
`;

export const DateInfoSectionWrapper = styled(SubHeading)`
	padding: 8px 0px 8px 0px;
`;

export const PageTitle = styled.div`
	padding-top: 24px;
	font-size: 16px;
	text-transform: capitalize;
	font-weight: 600;
	color: ${CSS_CONSTANTS.v2_text_gray};
	position: sticky;
	left: 66px;
`;

export const HeaderPageContainer = styled.div`
	.header-bar {
		flex-grow: 1;
		padding: 16px 24px;
		&.no-padding {
			padding: 0;
		}
		.info-component-icon-wrapper {
			margin-left: 0;
			margin-right: 16px;
			top: 3px;
			.tooltip-right {
				font-size: 16px;
				line-height: 1.5;
			}
		}
	}
	@media screen and (min-width: 2137px) {
		display: flex;
		flex-direction: column;
		align-items: center;
		.top-header-bar {
			padding: 16px 0 0;
			width: 2065px;
		}
		.header-bar {
			padding: 16px 0 16px;
			width: 2065px;
		}
	}
`;

export const InnerTopSectionWrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: row;
	margin-bottom: 24px;
`;

export const afterRules = `
content: '';
position: absolute;
top: -1px;
right: -1px;
bottom: -1px;
left: -1px;
z-index: 3;
`;

export const PeriodBarWrapper = styled.div`
	display: flex;
	margin-top: 24px;
	flex-direction: row;
	height: 20px;
	width: 100%;
	.current-date-range {
		flex-grow: 1;
		font-size: 16px;
		font-weight: 500;
		color: ${CSS_CONSTANTS.v2_text_gray};
		.week-number {
			font-weight: normal;
		}
	}
	.total-hours-container {
		display: flex;
		flex-direction: row;
		flex-grow: 0;
		align-self: flex-end;
		font-size: 16px;
		font-weight: 500;
		color: ${CSS_CONSTANTS.v2_text_gray};
		.total-text {
			margin-right: 16px;
		}
	}
`;
